import { SyncProgress } from '@/assets/icons'

type InitialExternalSyncStatusProps = {
  description: string
  sourceLabel: string
}

export function InitialExternalSyncStatus({ description, sourceLabel }: InitialExternalSyncStatusProps) {
  return (
    <div className="flex h-full min-w-0 items-center gap-2" role="status" aria-live="polite">
      <SyncProgress className="size-4 shrink-0 animate-spin text-brand-500 motion-reduce:animate-none" aria-hidden />
      <p className="min-w-0 truncate text-sm leading-5">
        <span className="font-medium text-brand-neutral-950">Syncing from {sourceLabel}</span> <span className="text-brand-neutral-600">{description}</span>
      </p>
    </div>
  )
}
